import styled from "styled-components";

type TableScrollContainerProps = {
  $hasPagination?: boolean;
};

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  max-height: 100vh;
  min-height: 0;
  overflow: hidden;
`;

export const TableScrollContainer = styled.section<TableScrollContainerProps>`
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  min-width: 0;
  padding-bottom: ${({ $hasPagination }) => ($hasPagination ? "60px" : "0")};
`;

export const TableHorizontalScrollContainer = styled.div`
  width: 100%;
  min-width: 0;
  overflow-x: auto;
`;
